import { gql } from '@apollo/client';
import { CRM_ACCOUNT_DETAIL_FIELDS } from './queries';

export const CREATE_CRM_ACCOUNT = gql`
    mutation CreateCrmAccount($input: CreateCrmAccountInput!) {
        createCrmAccount(input: $input) {
            _id
            businessName
            stageKey
            status
        }
    }
`;

export const DELETE_CRM_ACCOUNT = gql`
    mutation DeleteCrmAccount($accountId: String!) {
        deleteCrmAccount(accountId: $accountId) {
            message
        }
    }
`;

export const UPDATE_CRM_ACCOUNT = gql`
    mutation UpdateCrmAccount($input: UpdateCrmAccountInput!) {
        updateCrmAccount(input: $input) {
            _id
            businessName
            stageKey
            leadSource
            tags
            status
        }
    }
`;

export const MOVE_CRM_ACCOUNT_STAGE = gql`
    mutation MoveCrmAccountStage($input: MoveCrmAccountStageInput!) {
        moveCrmAccountStage(input: $input) {
            _id
            stageKey
            stageEnteredAt
            stageSource
            status
            wonAt
            lostAt
        }
    }
`;

export const ADD_CRM_NOTE = gql`
    mutation AddCrmNote($input: AddCrmNoteInput!) {
        addCrmNote(input: $input) {
            ${CRM_ACCOUNT_DETAIL_FIELDS}
        }
    }
`;

export const EDIT_CRM_NOTE = gql`
    mutation EditCrmNote($input: EditCrmNoteInput!) {
        editCrmNote(input: $input) {
            ${CRM_ACCOUNT_DETAIL_FIELDS}
        }
    }
`;

export const DELETE_CRM_NOTE = gql`
    mutation DeleteCrmNote($input: DeleteCrmNoteInput!) {
        deleteCrmNote(input: $input) {
            ${CRM_ACCOUNT_DETAIL_FIELDS}
        }
    }
`;

export const LINK_CRM_ACCOUNT_BUSINESS = gql`
    mutation LinkCrmAccountBusiness($input: LinkCrmAccountBusinessInput!) {
        linkCrmAccountBusiness(input: $input) {
            ${CRM_ACCOUNT_DETAIL_FIELDS}
        }
    }
`;

export const MERGE_CRM_ACCOUNTS = gql`
    mutation MergeCrmAccounts($input: MergeCrmAccountsInput!) {
        mergeCrmAccounts(input: $input) {
            ${CRM_ACCOUNT_DETAIL_FIELDS}
        }
    }
`;

export const SET_CRM_ACCOUNT_POGOZO_DEMO = gql`
    mutation SetCrmAccountPogozoDemo($input: SetPogozoDemoInput!) {
        setCrmAccountPogozoDemo(input: $input) {
            ${CRM_ACCOUNT_DETAIL_FIELDS}
        }
    }
`;

/* CMS team member logging into a linked business (POGO-13282) */
export const REQUEST_BUSINESS_LOGIN = gql`
    mutation RequestBusinessLogin($input: RequestBusinessLoginInput!) {
        requestBusinessLogin(input: $input) {
            expiresAt
            expiresBy
        }
    }
`;

export const VERIFY_BUSINESS_LOGIN = gql`
    mutation VerifyBusinessLogin($input: VerifyBusinessLoginInput!) {
        verifyBusinessLogin(input: $input) {
            accessToken
            businessId
        }
    }
`;

export const MARK_CRM_ACCOUNT_DUPLICATE = gql`
    mutation MarkCrmAccountDuplicate($input: MarkCrmAccountDuplicateInput!) {
        markCrmAccountDuplicate(input: $input) {
            _id
        }
    }
`;

/* Flag/unflag an account out of reporting (POGO-13862) — fake/spam/test lead. */
export const SET_CRM_ACCOUNT_REPORTING_EXCLUDED = gql`
    mutation SetCrmAccountReportingExcluded($input: SetCrmAccountReportingExcludedInput!) {
        setCrmAccountReportingExcluded(input: $input) {
            _id
            excludedFromReporting
            excludedReason
        }
    }
`;
